import React from "react";
import styled from "styled-components";

import toolbarConnector from "modules/profileIDE/connectors/toolbar";
import fileListConnector from "modules/profileIDE/connectors/fileList";
import { ThreeColumnsLayout } from "modules/profileIDE/Layout";

import Toolbar from "modules/profileIDE/components/Toolbar";
import FileList from "modules/profileIDE/components/FileList";
import AppProfileEditor from "modules/profileIDE/components/Editor";

const LayoutWrap = styled.div`
  height: calc(100% - 64px);
`;

const ConnectedToolbar = toolbarConnector.connect(Toolbar);
const ConnectedFileList = fileListConnector.connect(FileList);

export default function Layout() {
  return (
    <LayoutWrap>
      <ThreeColumnsLayout />
      <ThreeColumnsLayout.Toolbar>
        <ConnectedToolbar />
      </ThreeColumnsLayout.Toolbar>
      <ThreeColumnsLayout.Files>
        <ConnectedFileList />
      </ThreeColumnsLayout.Files>
      <ThreeColumnsLayout.Editor>
        <AppProfileEditor />
      </ThreeColumnsLayout.Editor>
    </LayoutWrap>
  );
}
